import {useDevice} from 'platform/foundation';

import {prop} from 'ramda';

import type {DashboardBusinessCaseResponseBody} from '@dms/api/core';

import {DashboardTileSize} from '../../../types/DashboardTileSize';
import {DASHBOARD_TILE_NATURAL_ROWS} from '../../../utils/dashboardTileNaturalRows';
import {DASHBOARD_TILE_ROW_COLUMNS} from '../../../utils/dashboardTileRowColumns';
import {DASHBOARD_TILE_ROW_SPACING} from '../../../utils/dashboardTileRowSpacing';
import {DashboardTileRows} from '../../DashboardTileRows/DashboardTileRows';
import {LatestBusinessCaseItem} from './LatestBusinessCaseItem';

interface LatestBusinessCaseRowsProps {
  businessCases: DashboardBusinessCaseResponseBody[];
  size: DashboardTileSize;
  isPreview?: boolean;
  naturalRows?: number;
}

export function LatestBusinessCaseRows(props: LatestBusinessCaseRowsProps) {
  const device = useDevice();
  const effectiveSize = device === 'mobile' ? 'half' : props.size;

  return (
    <DashboardTileRows
      id="latest-business-cases"
      rows={props.businessCases}
      getRowKey={(businessCase) => businessCase.id}
      getRowLayoutKey={(businessCase) => JSON.stringify(businessCase)}
      renderRow={(businessCase, options) => (
        <LatestBusinessCaseItem
          businessCase={businessCase}
          isProbe={options.isProbe}
          isPreview={props.isPreview}
        />
      )}
      naturalRows={props.naturalRows ?? DASHBOARD_TILE_NATURAL_ROWS}
      spacing={DASHBOARD_TILE_ROW_SPACING}
      columns={prop(effectiveSize, DASHBOARD_TILE_ROW_COLUMNS)}
    />
  );
}
